import { IngredientDto } from '@/services/api/api-client';

/**
 * A "new calculation" card that lives on the calculations board without existing on the backend.
 * Nothing is persisted until the card is saved, so a draft has no calculation id, no history and no
 * sortOrder of its own - its place among the real cards is kept here.
 */
export type CalculationDraft = {
  /**
   * Negative, so a draft shares the number-keyed transient stores (dirty flags, selection, stull
   * points) with the persisted calculations without ever colliding with a real id.
   */
  id: number;
  mode: CalculationDraftMode;
  /** Position among the persisted calculations: the draft renders before `calculations[index]`. */
  index: number;
  /** The template a `calculator` draft opens with; unset when it was started empty. */
  template?: CalculationDraftTemplate;
};

/** Which of the three ways to reach a calculation the draft is currently walking through. */
export type CalculationDraftMode = 'chooser' | 'calculator' | 'template' | 'inverse';

/** What picking a template hands to the calculator step: its ingredients and the name to reuse. */
export type CalculationDraftTemplate = {
  name: string;
  recipe: IngredientDto[];
};

/** Tells a draft card apart from a persisted calculation by its id alone. */
export const isCalculationDraftId = (id: number) => id < 0;
